import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import MenuSection from "./components/MenuSection";
import StopHereSection from "./components/StopHereSection";
import ReviewsSection from "./components/ReviewsSection";
import LocationsSection from "./components/LocationsSection";
import PhotosSection from "./components/PhotosSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <MenuSection />
      <StopHereSection />
      <ReviewsSection />
      <LocationsSection />
      <PhotosSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
